// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26a9N","delete":"styles_delete__6Sm1w","update":"styles_update__1UPXy","add":"styles_add__zKjPH"};